import { Component } from '@angular/core';

@Component({
    selector: 'gbc-page-container',
    templateUrl: './page-container.component.html',
    styleUrls: ['./page-container.component.scss'],
})
export class PageContainerComponent {
  constructor() {}
}
